import { EMAIL_OPT_IN_MODAL_SUCCESS_VIEW } from 'core/modules/Modals/EmailOptInSuccessModal/actions/types';

export const triggerEmailOptInModalSuccessIsViewed = () => ({
  type: EMAIL_OPT_IN_MODAL_SUCCESS_VIEW,
});
